import React from 'react';
import BadgeCard from '../BadgeCard';
import styles from './styles.module.css';

export default function BadgeList({
  list,
  active = false,
  onClick,
  activeKey = 'id',
  className = '',
  title,
  error,
  showError = false,
  bg,
}: {
  list?: any;
  active?: boolean;
  onClick?: (x: any) => void;
  activeKey?: string | number;
  className?: string;
  title?: string;
  error?: string;
  showError?: boolean;
  bg?: string;
}) {
  console.log('error==', error, showError);
  return (
    <div className={`${className}`}>
      {title && (
        <span className={`formTitle`}>
          <span>{title}</span>{' '}
        </span>
      )}
      <div className={`${styles.listContainer} `}>
        {list?.map((item: any, index: number) => (
          <BadgeCard
            key={index}
            item={{ ...item }}
            mainStyle="hover"
            className={`${styles.singleTag} ${active == item?.[activeKey] && styles.activeTag}`}
            showdot={false}
            extraText={null}
            onClick={() => {
              onClick && onClick(item);
            }}
            bg={item?.bg}
          />
        ))}
      </div>
      {showError == true && <p className={`inputErrorText ${styles.error}`}>{error}</p>}
    </div>
  );
}
